import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog"
import { Loader2 } from "lucide-react"
import { UserDomain } from "@/types/domains.tsx"
import { useRemoveDomainFromPostmark } from "@/hooks/usePostmarkDomain"

function RemoveEmailDialog({ 
  showRemove, 
  setShowRemove, 
  userDomain, 
}: {
  showRemove: boolean, 
  setShowRemove: (open: boolean) => void, 
  userDomain: UserDomain, 
}) {
  const { mutate: deleteEmail, isPending: removeEmailLoading } = useRemoveDomainFromPostmark(); 
  return (
    <AlertDialog open={showRemove} onOpenChange={setShowRemove}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Remove Email</AlertDialogTitle>
      </AlertDialogHeader>
      <AlertDialogDescription>
        Are you sure you want to delete <span className="font-bold text-red-500 underline">{userDomain?.email_from_address}</span> email?
      </AlertDialogDescription>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction 
           className="bg-red-600 hover:bg-red-700" 
           onClick={(e) => {
             e.preventDefault();
             deleteEmail(undefined, { onSuccess: () =>  setShowRemove(false) });
           }}
           disabled={removeEmailLoading}
           >
            {removeEmailLoading 
              ? <><Loader2 className="mr-2 size-5 animate-spin" />Deleting... </>
              : <>Delete</>
            }
          </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  )
}

export default RemoveEmailDialog